import React from 'react';
import { BaseIcon } from '../base/BaseIcon';
import { IconProps } from '../types';

export const UndoFill = React.memo<IconProps>(
  ({
    className = '',
    size = 24,
    color = 'currentColor',
    onClick,
    strokeWidth,
  }) => (
    <BaseIcon
      className={className}
      size={size}
      color={color}
      onClick={onClick}
      viewBox="0 0 12 12"
    >
      <path
        d="M10.0528 5.6624C9.14509 4.75885 7.76814 4.30035 5.85064 4.2642V2.39995C5.85064 2.2818 5.78419 2.1739 5.67874 2.1209C5.57354 2.0677 5.44704 2.07845 5.35209 2.149L0.922895 5.4327H0.922145C0.772945 5.54375 0.687495 5.7144 0.687745 5.9007C0.687995 6.08675 0.773695 6.2569 0.922845 6.36755L5.35199 9.651C5.44695 9.7208 5.57319 9.73155 5.67864 9.6793C5.78414 9.62605 5.85054 9.51815 5.85054 9.4V7.57235C7.96774 7.5753 9.78124 7.65195 10.7202 9.5392C10.7739 9.6471 10.8833 9.71255 11 9.71255C11.0234 9.71255 11.0479 9.7101 11.0713 9.70425C11.2129 9.67105 11.3125 9.54505 11.3125 9.40005C11.3125 7.72915 10.9004 6.5064 10.0528 5.6624Z"
        fill={color}
      />
    </BaseIcon>
  ),
);

UndoFill.displayName = 'UndoFill';
